import { Component, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigProductService } from '../config_product.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'configure-sub-product',
    templateUrl: './config_sub_product.component.html'
})
export class ConfigureSubProduct {

    collectionDetails = [];
    searchDataPafing = [];

    indexStart = 0;
    indexEnd = 10;
    pageSize = 5;
    pageNo = 1;
    totalPage = [1];

    searchInput = '';
    IsRecordUpdated = false;

    productId = '';
    productName = '';
    productCode = '';
    ButtonValue = 'Save';
    productGroupType = '';
    viewMode = false;
    CreatedBy = '';
    IsDeleting = false;
    DeletedIndex = '';

    productArray = [];


    constructor(private router: Router,
        public toastr: ToastsManager, vcr: ViewContainerRef,
        private PaymentService: ConfigProductService,
        private fb: FormBuilder) {
        this.toastr.setRootViewContainerRef(vcr);

        this.PaymentService.GetProducts(null)
            .subscribe(departmentListData => {
                this.productArray = departmentListData;
            });


        this.PaymentService.GetSubProducts(null)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }


    pagingAgent(data) {
        this.pageNo = data;
        this.indexStart = (this.pageNo - 1) * this.pageSize + 1;
        this.indexEnd = (this.pageNo) * this.pageSize;
    }

    changeItemsPerPage(data) {
        if (this.collectionDetails.length > 0) {
            this.totalPage = [1]
            let j = 1;
            for (var i = 0; i < this.collectionDetails.length; i++) {
                i = i + this.pageSize;
                j = j + 1;
                this.totalPage.push(j);
            }
        }
        else {
            this.totalPage = [];
        }
        this.pageSize = data;
        this.indexStart = 0;
        this.indexEnd = this.pageSize;
    }

    searchInputFunction() {
        this.PaymentService.GetSubProducts(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }

                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }

    UpdateRecordsPopulate(obj) {
        this.viewMode = false;
        this.productName = obj["name"];
        this.productCode = obj["customId"];
        this.productId = obj["id"];
        this.IsRecordUpdated = true;
        this.ButtonValue = 'Update';
        this.productGroupType = obj["productGroupId"];
        this.CreatedBy = obj["lastModifiedBy"];
    }

    ViewRecordsPopulate(obj) {
        this.viewMode = true;
        this.productName = obj["name"];
        this.productCode = obj["customId"];
        this.productId = obj["id"];
        this.IsRecordUpdated = true;
        this.ButtonValue = 'Save';
        this.productGroupType = obj["productGroupId"];
    }
    reset() {
        this.viewMode = false;
        this.productName = '';
        this.productCode = '';
        this.productId = '';
        this.IsRecordUpdated = false;
        this.ButtonValue = 'Save';
        this.productGroupType = '';
    }

    memberFormSubmit() {

        //this.productGroupType = '';

        for (var i = 0; i < this.productArray.length; i++) {
            if (this.productArray[i]["id"] == this.productGroupType) {
                this.productName = this.productArray[i]["name"];
            }
        }


        if (this.productId != '') {
            let data = {
                "ProductCode": this.productCode,
                "Id": this.productId,
                "ProductName": this.productName,
                "ProductGroupId": this.productGroupType,
                "LastModifiedBy": '',
                "CreatedBy": this.CreatedBy,
                "group": this.productName,
                'profileIdentifications': []
            }

            this.PaymentService.EditProduct(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record updated succesfuly.");
                        this.LoadGrid();
                        this.reset();
                    }
                    else {
                        this.toastr.error("Name,Code and their combination must be Unique");
                    }
                });
        }
        else {
            let data = {
                "ProductCode": this.productCode,
                "Id": '',
                "ProductName": this.productName,
                "ProductGroupId": this.productGroupType,
                "LastModifiedBy": '',
                "CreatedBy": this.CreatedBy,
                "group": this.productName,
                'profileIdentifications': []
            }
            this.PaymentService.CreateProduct(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record Added succesfuly.");
                        this.LoadGrid();
                        this.reset();
                    }
                    else {
                        this.toastr.error("Name,Code and their combination must be Unique");
                    }
                });
        }


    }

    codegen() {
        this.PaymentService.codeGen(this.productName)
            .subscribe(departmentListData => {
                this.productCode = departmentListData;
            });
    }

    deleteProdutConfirm(id, i) {
        this.productId = id;
        this.IsDeleting = true;
        this.DeletedIndex = i;
    }
    delete() {
        let data = {
            "id": this.productId,
            "trackingState": this.DeletedIndex
        }
        this.PaymentService.DeleteProductGroup(data)
            .subscribe(departmentListData => {

            });
    }
    deleteCancel() {
        this.IsDeleting = false;
        this.productId = '';
        this.DeletedIndex = '';
    }

    LoadGrid() {
        this.PaymentService.GetProducts(null)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }

                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/configure_product/config_sub_product/config_sub_product.component.ts